module.exports = __webpack_public_path__ + "static/media/short-hit.69f1fd46.png";